<div class="row">
    <div class="col-md-8">
        <h4 class="font-weight-bold">&nbsp;&nbsp;{{formTitle}}</h4>
    </div>
    <div class="col-md-4 text-right">
        <button class="btn btn btn-sm btn-primary btn-square" id="addEmployeeBackBtn" type="button" (click)="onBack()">Back</button>
    </div>
</div>
<app-example-wrapper-seamless>
    <div class="card card-box mb-5">
        <div class="card-body">
            <!-- <h5 class="card-title font-weight-bold font-size-lg mb-4">Tax Service</h5> -->
            <form [formGroup]="taxForm">
                <div class="row">

                    <div class="col-md-6 col-sm-6">
                        <div class="form-group">
                            <label for="station">Station *</label>
                            <ng-select id="station" required formControlName="station" [ngClass]="{'is-invalid': submitted && f.station.errors}" placeholder="Select Station" (change)="onStationChange($event)">
                                <ng-option *ngFor="let station of allStations" [value]="station.StationCode">
                                    {{station.STATIONID}} - {{station.AirportName}}
                                </ng-option>
                            </ng-select>
                            <div *ngFor="let validation of validation_messages.station">
                                <div class="error-message" *ngIf="f.station.hasError(validation.type) &&  ((f.station.dirty || f.station.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6 col-sm-6">
                        <div class="form-group">
                            <label for="t_slab">Tax Slab *</label>
                            <input id="t_slab" class="form-control" formControlName="tax_Slab" placeholder="Tax Slab " type="number" [ngClass]="{'is-invalid': submitted && f.tax_Slab.errors}">
                            <div *ngFor="let validation of validation_messages.tax_Slab">
                                <div class="error-message" *ngIf="f.tax_Slab.hasError(validation.type) && ((f.tax_Slab.dirty  || f.tax_Slab.touched))">
                                    {{validation.message }}
                                </div>
                            </div>
                        </div>
                    </div>

        </div>

        <div class="row"> 

            <div class="col-md-6 col-sm-6">
                <div class="form-group">
                    <label for="t_label">Tax Label *</label>
                    <input id="t_label" class="form-control" formControlName="tax_Label" placeholder="Tax Label" type="text" [ngClass]="{'is-invalid': submitted && f.tax_Label.errors}">
                    <div *ngFor="let validation of validation_messages.tax_Label">
                        <div class="error-message" *ngIf="f.tax_Label.hasError(validation.type) && ((f.tax_Label.dirty  || f.tax_Label.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-6 col-sm-6">
                <div class="form-group">
                    <label for="tld">Tax Label Description *</label>
                    <input id="tld" class="form-control" formControlName="tax_Label_Description" placeholder="Tax Label Description" type="text" [ngClass]="{'is-invalid': submitted && f.tax_Label_Description.errors}">
                    <div *ngFor="let validation of validation_messages.tax_Label_Description">
                        <div class="error-message" *ngIf="f.tax_Label_Description.hasError(validation.type) && ((f.tax_Label_Description.dirty  || f.tax_Label_Description.touched))">
                            {{validation.message }}
                        </div>
                    </div>
                </div>
            </div>

                    <!-- <div class="col-lg-4 col-sm-6" *ngIf="isEditMode">
                        <div class="form-group">
                            <label for="LCB">LCB ID</label>
                            <input id="LCB" class="form-control" formControlName="LCB_ID" placeholder="LCB ID" type="number" [ngClass]="{'is-invalid': submitted && f.LCB_ID.errors}">
                             <div *ngFor="let validation of validation_messages.LCB_ID">
                                <div class="error-message" *ngIf="f.LCB_ID.hasError(validation.type) && ((f.LCB_ID.dirty  || f.LCB_ID.touched))">
                                    {{validation.message }}
                                </div>
                            </div> 
                        </div>
                    </div> -->

                    <!-- <div class="col-md-4 col-sm-6" *ngIf="isEditMode">
                        <div class="form-group">
                            <label for="t_id">Tax ID</label>
                            <input id="t_id" class="form-control" formControlName="tax_ID" placeholder="Tax ID" type="number" [ngClass]="{'is-invalid': submitted && f.tax_ID.errors}">
                             <div *ngFor="let validation of validation_messages.tax_ID">
                                <div class="error-message" *ngIf="f.tax_ID.hasError(validation.type) && ((f.tax_ID.dirty  || f.tax_ID.touched))">
                                    {{validation.message }}
                                </div>
                            </div> 
                        </div>
                    </div> -->

                </div>

                <div class="row"> 

                    <!-- <div class="col-md-3 col-sm-6" *ngIf="isEditMode">
                        <div class="form-group">
                            <label for="empid">Status</label>
                            <ng-select  id="active" required formControlName="active" [ngClass]="{'is-invalid': submitted && f.active.errors}" placeholder="Select Status">
                                <ng-option *ngFor="let status of statusTypes" [value]="status.id">
                                    {{status.name}}
                                </ng-option>
                            </ng-select>
                        </div>
                    </div> -->

                </div>
               
                <div class="row">
                    <div class="col-md-12 py-3">
                        <!-- <button id="backBtn" class="btn btn m-2 btn-neutral-primary btn-square" type="button" (click)="onBack()">Back</button> -->
                        <button id="saveTaxBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onAddTax(taxForm.value)" *ngIf="!isEditMode">Add Tax</button>

                        <button id="updateTaxBtn" class="btn m-2 btn-primary btn-square" type="button" (click)="onUpdateTax(taxForm.value)" *ngIf="isEditMode">Update Tax </button>
                        <!-- <button id="resetBtn" class="btn m-2 btn-dark btn-square" type="button" (click)="onRest()">Reset</button> -->
                    </div>
                </div>
            </form>
        </div>
    </div>
    <notifier-container></notifier-container>
</app-example-wrapper-seamless>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>